import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newlineToBreak'
})
export class NewlineToBreakPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value; // Handle null or undefined values
    return value.replace(/\n/g, '<br />'); // Replace \n with <br>
  }

}
